import { reactive, readonly } from 'vue';
import { showFailToast } from 'vant';
import i18n from '@/i18n';
import {
  isCameraSecureContext,
  mapCameraErrorMessage,
  resolveCameraGuideType,
  showCameraGuide
} from '@/utils/camera';

const scannerState = reactive({
  visible: false,
  back: '',
  query: {},
  stateNamespace: '',
  statePayload: {},
  streamVersion: 0
});

let scannerStream = null;

function stopWalletScannerStream() {
  scannerStream?.getTracks().forEach((track) => track.stop());
  scannerStream = null;
}

export function useWalletScanner() {
  async function openWalletScanner(options = {}) {
    if (!isCameraSecureContext()) {
      showFailToast(i18n.global.t('wallet.cameraSecureContextRequired'));
      showCameraGuide('secure');
      return false;
    }

    if (!navigator.mediaDevices?.getUserMedia) {
      showFailToast(i18n.global.t('wallet.cameraUnavailable'));
      showCameraGuide('unavailable');
      return false;
    }

    stopWalletScannerStream();

    try {
      scannerStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' }
      });
    } catch (error) {
      showFailToast(mapCameraErrorMessage(error));
      showCameraGuide(resolveCameraGuideType(error, 'unavailable'));
      return false;
    }

    scannerState.back = String(options.back || '').trim();
    scannerState.query = { ...(options.query || {}) };
    scannerState.stateNamespace = String(options.stateNamespace || '').trim();
    scannerState.statePayload = { ...(options.statePayload || {}) };
    scannerState.visible = true;
    scannerState.streamVersion += 1;
    return true;
  }

  function closeWalletScanner() {
    scannerState.visible = false;
    stopWalletScannerStream();
  }

  function resetWalletScanner() {
    scannerState.visible = false;
    scannerState.back = '';
    scannerState.query = {};
    scannerState.stateNamespace = '';
    scannerState.statePayload = {};
    scannerState.streamVersion = 0;
    stopWalletScannerStream();
  }

  function getWalletScannerStream() {
    return scannerStream;
  }

  return {
    scannerState: readonly(scannerState),
    openWalletScanner,
    closeWalletScanner,
    resetWalletScanner,
    getWalletScannerStream,
    stopWalletScannerStream,
    showWalletScannerGuide: showCameraGuide
  };
}
